module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-nb.35ac95160b148f7d06a9.svg";